$(document).ready(function() {

	console.log('app loaded');

	// Check to see if anything is in the viewport

	 $.fn.isInViewport = function() {
	  var elementTop = $(this).offset().top;
	  var elementBottom = elementTop + $(this).outerHeight();

	  var viewportTop = $(window).scrollTop();
	  var viewportBottom = viewportTop + $(window).height();

	  return elementBottom > viewportTop && elementTop < viewportBottom;
	};


	// Variables

	var body = $('body'),
	menuToggle = $("#menu-toggle"),
	scheduleToggle = $('#schedule-toggle'),
	radicalBroadcast = $('#radical-broadcast'),
	footer = $('footer.footer');


	// Tickers

	setTimeout(function() {
		$('.ticker').addClass('loaded');
	}, 250);


	// Check if Footer is in Viewport

	// if (footer.isInViewport()) {
	// 	body.addClass('footer-present');
	// } else {
	// 	body.removeClass('footer-present');
	// }

		$(window).on('resize scroll', function() {

			if (footer.isInViewport()) {
				body.addClass('footer-present');
			} else {
				body.removeClass('footer-present');
			}

		});
	


	// Navigation

//	$.fn.extend({
//	    toggleText: function(a, b){
//	        return this.text(this.text() == b ? a : b);
//	    }
//	});

//	menuToggle.on('click', function(evt) {

//		scheduleToggle.removeClass('active');
//		body.removeClass('schedule-open');

//		$(this).toggleText('Menu', 'Close');
//		$(this).toggleClass('active');

//		body.toggleClass('nav-open');

//		evt.preventDefault();
//		return false;
//	});

	menuToggle.hover(
		function() {
			$('.breadcrumb').css('opacity','0.075').css('color','black');
		}, function() {
			$('.breadcrumb').css('opacity','1.0').css('color','');
		}
	);
	
	$('.nav-group-title').on('click', function(evt) {
		body.removeClass('nav-open');
		return false;
	});


	$(".protect").click(function (evt) {
		body.removeClass('schedule-open');
		scheduleToggle.removeClass('active');
		evt.preventDefault();
		return false;
	});

	$(".sched-open").each(function (evt) {
		$(this).removeClass('sched-open');
	});

	// Fade out Breadcrumbs when Footer is present


	var distance = footer.offset().top + 64;

	if ( $(window).scrollTop() >= distance ) {
	    $('.breadcrumb').css('opacity','0');
	} else {
		$('.breadcrumb').css('opacity','1');
	}

	$(window).scroll(function() {
	    if ( $(window).scrollTop() >= distance ) {
	        $('.breadcrumb').css('opacity','0');
	    } else {
	    	$('.breadcrumb').css('opacity','1');
	    }
	});




	// Index


	if (body.hasClass('template-index')){

		// Detect Mousemovement

		var timeout = null;

		$(document).on('mousemove', function() {

		    clearTimeout(timeout);
		    body.removeClass('mouse-paused');

		    timeout = setTimeout(function() {
		    	if (radicalBroadcast.isInViewport()) {
		        	body.addClass('mouse-paused');
		        }
		    }, 3000);
		});




		$(".week-container").not('.active').click(function (evt) {
			$(this).addClass('active');
		});

	}




	// Index


	if (body.hasClass('template-page')){

		var initialBread = $('.page-content').find('.breadcrumb-trigger:first-child').data('title');
		$('#section-title').text(initialBread);

		// Breadcrumb Update

		$(".page-content article").mouseenter(function(){
		   	var breadTitle = $(this).data('title');
			$('#section-title').text(breadTitle);
		});


		// Check for Featured Image


		if ($('figure.featured-image').length){

			$('.page-container').addClass('has-featured-image');

			// Fade to Black if it does exist
			

				var contentDistance = $('.page-content').offset().top;

				if ( $(window).scrollTop() >= contentDistance ) {
				    $('.breadcrumb').addClass('black');
				} else {
					$('.breadcrumb').removeClass('black');
				}

				$(window).scroll(function() {
				    if ( $(window).scrollTop() >= contentDistance ) {
				        $('.breadcrumb').addClass('black');
				    } else {
				    	$('.breadcrumb').removeClass('black');
				    }
				});
		}

		
	}


	// Safari Hack
	$("video").prop('muted', true);
	$(".safari-fix").click( function (){
    	if( $("#rb-video").prop('muted') ) {
          $("video").prop('muted', false);
          console.log('unmuted');
    	} else {
      		$("video").prop('muted', true);
      		console.log('muted');
    	}
  	});


});
